import { ScenarioBuildStatusTypeBase } from './base/scenario-build-status-type-base';

export class ScenarioBuildStatusType extends ScenarioBuildStatusTypeBase { }